import stream from "mithril/stream";
import m from "mithril";
import { view } from "./canvas";
import { AM40, AM20, AMOrbital } from "./DcMotor";
import { sixWheelOmni, mecanum, slideDrive, omniDrive } from "./drivetrains";
import { App, state } from "./App";

var wheel_radius = 0.0508; // meters
var wheel_mass = 0.141748; // kg
var wheel_thickness = 0.0508; // meters
var start_point = { x: 0.6096, y: 1.2192 };
var start_heading = 0;
var width = 0.4572; // meters
var height = 0.4572; // meters

var robotTypes = {
  Mecanum: mecanum,
  "6 Wheel Omni": sixWheelOmni,
  "Slide Drive": slideDrive,
  "Omni Drive": omniDrive
};

var motorTypes = {
  "Andymark 40": AM40,
  "Andymark 20": AM20,
  "Andymark Orbital": AMOrbital
};

function initialModelCreator(mass, robotType, motorType) {
  return {
    tab: "editTab",
    lessonTab: "lesson1Tab",
    gamepad1_index: null,
    gamepad2_index: null,
    motors: robotTypes[robotType](
      motorTypes[motorType],
      mass,
      wheel_mass,
      wheel_radius,
      width,
      height
    ),
    real_time: true,
    initial_time: 0,
    previous_time: 0,
    pos: start_point,
    heading: start_heading,
    gyro_heading: 0,
    omega: 0,
    v_local: { x: 0, y: 0 },
    v: { x: 0, y: 0 },
    a: { x: 0, y: 0 },
    a_local: { x: 0, y: 0 },
    dt: 0.03,
    current_time: 0,
    canvas_size: 500,
    pixels_per_meter: 136.701662292, // pixels per meter
    width: width, // meters
    height: height, // meters
    wheel_thickness: wheel_thickness,
    wheel_radius: wheel_radius,
    motor_type: motorTypes[motorType],
    cof: 1,
    mass: mass, // kg
    gear_ratio: 1,
    robot_type: robotType
  };
}

const original_state = Object.assign(
  {},
  initialModelCreator(9.07185, "6 Wheel Omni", "Andymark Orbital")
);

const update = stream();
const applyUpdate = (model, modelUpdate) => modelUpdate(model);
const models = stream.scan(applyUpdate, original_state, update);

function startRendering() {
  models.map(model => {
    m.render(document.body, App.view(model));
    return view(model);
  });
}

export { update, models, initialModelCreator, startRendering };



//////////////////
// WEBPACK FOOTER
// ./src/streams.js
// module id = 0
// module chunks = 0